var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.9394,
    height: 33.9394,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1509_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 24.8547V26.6667H10.3055C9.29807 26.6667 8.48486 25.8513 8.48486 24.8487V7.27274H10.3055V23.8038L11.7802 12.7086C11.8773 12.0019 12.4417 11.4342 13.1517 11.3376C14.9359 11.096 19.7666 10.6128 26.1023 11.3496L25.8899 13.1495C19.8273 12.4428 15.1058 12.9139 13.5644 13.1133L11.9986 24.8487H26.6667V24.8547Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1818,
    height: 19.3939,
    fill: "white",
    transform: "translate(8.48486 7.27274)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsc);
export default __webpack_public_path__ + "static/media/ssc.e575a6b4fddb00844b5abcd0559afaac.svg";
export { ForwardRef as ReactComponent };